export default __webpack_public_path__ + "static/media/016-melon.422ff2c6.svg";